import moment from "moment";

export const createEventGtag = (value) => {
  window.gtag("event", value);
};

export const getParamUrl = (key) => {
  let search = window.location.search;
  let arr = search.split("?");
  let params = new URLSearchParams(arr[1]);
  let token = params.get(key) || "";
  return token;
};

export const formatMoney = (money) => {
  if (!money) return;
  const res = `${money || 0}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return res;
};

export const formatDate = (date) => {
  if (!date) return "";
  const newDate = moment(date).format("DD/MM/YYYY");
  return newDate !== "Invalid date" ? newDate : "--";
};

export const formatDateHour = (date) => {
  if (!date) return "";
  const newDate = moment(date).format("DD/MM/YYYY, HH:mm");
  return newDate !== "Invalid date" ? newDate : "--";
};

export const formatDiscountCurrency = (value) => {
  if (!value) return "";
  if (value >= 1000000) {
    return value / 1000000 + " triệu";
  } else {
    return value / 1000 + " nghìn";
  }
};

export const textWithoutTags = (str) => {
  if (!str) return;
  const res = `${str || ""}`.replace(/<[^>]+>/g, "");
  const stringWithUppercasedFirstChar =
    res.charAt(0).toUpperCase() + res.slice(1);
  return stringWithUppercasedFirstChar;
};

export const isEmailValid = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

export const hiddenPhoneNumber = (number) => {
  if (!number || number.length < 5) return number;
  const firstThree = number.slice(0, 3);
  const lastTwo = number.slice(-2);
  const starsLength = number.length - 5;
  const stars = "*".repeat(starsLength);
  return `${firstThree}${stars}${lastTwo}`;
};

export const hiddenEmail = (email) => {
  const atIndex = email.indexOf("@");
  if (atIndex === -1) return email;

  const localPart = email.substring(0, atIndex);
  const domainPart = email.substring(atIndex);

  if (localPart.length <= 4) {
    return email;
  }

  const firstTwo = localPart.slice(0, 2);
  const lastTwo = localPart.slice(-2);
  const stars = "*".repeat(localPart.length - 4);

  return `${firstTwo}${stars}${lastTwo}${domainPart}`;
};

export const checkTitleDocxtemplater = (arr, key, pbp_id) => {
  const hasTitle = (arr || [])
    .filter((b) => b.checked)
    .some((a) => (a.benefitsTitle || "").toLowerCase().includes(key));
  if (pbp_id && pbp_id === 126) {
    return hasTitle ? "Có" : "Không";
  }
  return hasTitle ? "✓" : "";
};

export const capitalizeName = (str) => {
  if (!str) return;
  const res = str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return res;
};

export const numberToWords = (num) => {
  if (num === 0) return "Không đồng";

  const ChuSo = [
    "không",
    "một",
    "hai",
    "ba",
    "bốn",
    "năm",
    "sáu",
    "bảy",
    "tám",
    "chín",
  ];
  const DonVi = ["", "nghìn", "triệu", "tỷ"];

  function readTriple(n) {
    let [tr, ch, dv] = [
      Math.floor(n / 100),
      Math.floor((n % 100) / 10),
      n % 10,
    ];
    let str = "";

    if (tr > 0) {
      str += ChuSo[tr] + " trăm";
      if (ch === 0 && dv > 0) str += " linh";
    }

    if (ch > 1) {
      str += " " + ChuSo[ch] + " mươi";
      if (dv === 1) str += " mốt";
      else if (dv === 5) str += " lăm";
      else if (dv > 0) str += " " + ChuSo[dv];
    } else if (ch === 1) {
      str += " mười";
      if (dv === 1) str += " một";
      else if (dv === 5) str += " lăm";
      else if (dv > 0) str += " " + ChuSo[dv];
    } else if (ch === 0 && dv > 0) {
      str += " " + ChuSo[dv];
    }

    return str.trim();
  }

  function convert(n) {
    let str = "";
    let i = 0;
    while (n > 0) {
      let triple = n % 1000;
      if (triple > 0) {
        let prefix = readTriple(triple);
        str = prefix + (DonVi[i] ? " " + DonVi[i] : "") + " " + str;
      }
      n = Math.floor(n / 1000);
      i++;
    }
    return str.trim();
  }

  const result = convert(num);

  return result.charAt(0).toUpperCase() + result.slice(1) + " đồng";
};

export function resolveIdentifier(value) {
  if (/^\d{16,20}$/.test(value)) {
    return { type: "flakeId", value };
  }

  if (/^[a-zA-Z0-9_-]{6,}$/.test(value)) {
    return { type: "token", value };
  }

  return null;
}

export function checkDuplicatedAndSetLink(links) {
  if (links.length % 2 !== 0) return links;

  const half = links.length / 2;
  if (links.slice(0, half) === links.slice(half)) {
    return links.slice(0, half);
  };

  return links;
}

export function getInforByProviderId(id){
  switch (id) {
    case 16: //Bảo hiểm Bảo Việt
    case 40: //Bảo Hiểm Bảo Việt - An Phú
    case 44: //Bảo hiểm Bảo Việt - Bến Thành
      return {
        name: "Tổng công ty Bảo hiểm Bảo Việt",
        address: "Số 8 Lê Thái Tổ, Hoàn Kiếm, TP.Hà Nội",
        taxCode: "0101527385",
        email: "insurancehelp@baoviet.com.vn",
      }

    case 12:
      return {
        name: "Tổng Công Ty Cổ Phần Bảo Minh",
        address: "26 Tôn Thất Đạm, Phường Sài Gòn, TP. Hồ Chí Minh",
        taxCode: "0300446973",
        email: "baominhtructuyen@gmail.com",
      }
      
    case 3: //Bảo hiểm Dầu Khí - Phía Nam
    case 27: //Bảo hiểm PVI - PVI Đồng Khởi
    case 35: //Bảo hiểm Dầu Khí - Nam Sài Gòn
      return {
        name: "Tổng Công ty Bảo hiểm PVI",
        address: "Tầng 24, Toà nhà PVI Tower, lô VP2 Yên Hoà, Phường Cầu Giấy, Thành phố Hà Nội",
        taxCode: "0105402531",
        email: "baohiempvi@pvi.com.vn",
      }

    case 17:
      return {
        name: "Tổng Công Ty Cổ Phần Bảo Hiểm Ngân Hàng TMCP Công Thương Việt Nam",
        address: "Tầng 10-11, Tòa Nhà 126 Đội Cấn, Phường Ba Đình, Hà Nội",
        taxCode: "0101335193",
        email: "cskh@myvbi.vn",
      }

    case 7:
      return {
        name: "Công Ty Cổ Phần Bảo Hiểm Hùng Vương",
        address: "Tầng 5, Tòa Nhà Samsora Premier, 105 Chu Văn An, P. Hà Đông, Hà Nội",
        taxCode: "0305729654",
        email: "info@bhv.com.vn",
      }

    case 4: //Bảo hiểm Quân Đội - Phú Mỹ
    case 8: //Bảo hiểm Quân Đội - TPHCM
    case 15: //Bảo hiểm Quân Đội - Tràng An
      return {
        name: "Tổng Công ty Cổ phần Bảo hiểm Quân đội",
        address: "Tầng 5-6, Tòa Nhà MB, Số 21 Cát Linh, Phường Ô Chợ Dừa, Thành Phố Hà Nội",
        taxCode: "0102385623",
        email: "info@mic.vn",
      }

    case 20: //Bảo hiểm CHUBB
    case 42: //Bảo hiểm CHUBB-LIFE
      return {
        name: "Bảo hiểm Chubb",
        address: "-",
        taxCode: "-",
        email: "-",
      }

    case 18:
      return {
        name: "Tổng Công Ty Cổ Phần Bảo Hiểm Ngân Hàng Đầu Tư Và Phát Triển Việt Nam",
        address: "Tầng 11, Tòa Nhà Số 263 Đường Cầu Giấy, P.Cầu Giấy, Hà Nội",
        taxCode: "0100931299",
        email: "dvkh.bic@bidv.com.vn",
      }

    case 10: //Bảo hiểm DBV - SGD2
    case 33: //Bảo hiểm DBV - Kinh Đô
    case 34: //Bảo hiểm DBV - Vạn Xuân
    case 36: //Bảo hiểm DBV - PMH
    case 37: //Bảo hiểm DBV - Sài Gòn
    case 41: //Bảo Hiểm DBV - Thành An
      return {
        name: "Công Ty Cổ Phần Tập Đoàn Bảo Hiểm DBV",
        address: "Tầng 25 Tòa Nhà Vinacomin, Số 3 Dương Đình Nghệ, Phường Yên Hòa, TP. Hà Nội",
        taxCode: "0102737963",
        email: "dvkh@dbvi.com.vn",
      }

    case 19:
      return {
        name: "Tổng Công ty Cổ phần Bảo hiểm Sài Gòn - Hà Nội",
        address: "Tầng 24, Tòa Nhà Vinacomin, Số 3 Dương Đình Nghệ, Phường Yên Hòa, Thành Phố Hà Nội",
        taxCode: "0103085460",
        email: "info@bshc.com.vn",
      }

    case 21:
      return {
        name: "Công Ty TNHH Bảo Hiểm Fubon (Việt Nam)",
        address: "Tầng 15, Tòa Nhà Ree Tower, Số 9 Đoàn Văn Bơ, Phường Xóm Chiếu, TP.Hồ Chí Minh",
        taxCode: "0305836575",
        email: "cskh.ins@fubon.com",
      }

    case 22:
      return {
        name: "Công Ty TNHH Bảo Hiểm Phi Nhân Thọ Cathay Việt Nam",
        address: "46-48-50 Đường Phạm Hồng Thái, Phường Bến Thành, Thành Phố Hồ Chí Minh",
        taxCode: "0310483156",
        email: "Service@cathay-ins.com.vn",
      }

    case 25:
      return {
        name: "Bảo hiểm Liên Hiệp (UIC)",
        address: "-",
        taxCode: "-",
        email: "-",
      }

    case 26:
      return {
        name: "Bảo hiểm Pacific Cross",
        address: "-",
        taxCode: "-",
        email: "-",
      }

    case 32:
      return {
        name: "Bảo hiểm Dai-ichi",
        address: "-",
        taxCode: "-",
        email: "-",
      }

    case 30:
      return {
        name: "Công Ty Cổ Phần Bảo Hiểm Phi Nhân Thọ Techcom",
        address: "Tòa C5 D'Capitale, 119 Trần Duy Hưng, Phường Yên Hòa, Thành Phố Hà Nội",
        taxCode: "0110855978",
        email: "cskh@tcgi.com.vn",
      }
  
    default:
      return {}
  }
}